import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { messagesSupabase } from "./lib/supabase";
import "./ClientMessages.css";

function ClientMessages() {
  const { companyId } = useParams();

  console.log("Company ID from URL:", companyId);
  console.log("Supabase URL:", process.env.REACT_APP_SUPABASE_URL_MESSAGES);

  const [company, setCompany] = useState(null);
  const [conversations, setConversations] = useState([]);
  const [selectedConversation, setSelectedConversation] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadClientMessages() {
      setLoading(true);

      const { data: companyData, error: companyError } = await messagesSupabase
        .from("companies")
        .select("id, name")
        .eq("id", companyId)
        .single();

      if (companyError) {
        console.error("Company error full:", JSON.stringify(companyError, null, 2));
        setLoading(false);
        return;
      }

      setCompany(companyData);

      const { data: conversationData, error: conversationError } =
        await messagesSupabase
        .from("conversations")
        .select(`
          id,
          customer_phone,
          created_at,
          messages (
            id,
            direction,
            body,
            created_at
          )
        `)
        .eq("company_id", companyId)
        .order("created_at", { ascending: false });

      if (conversationError) {
        console.error("Conversation error:", conversationError);
        setLoading(false);
        return;
      }

      setConversations(conversationData || []);
      setSelectedConversation(conversationData?.[0] || null);
      setLoading(false);
    }

    loadClientMessages();
  }, [companyId]);

  if (loading) {
    return <div className="client-page">Loading messages...</div>;
  }

  if (!company) {
    return <div className="client-page">Company not found.</div>;
  }

  return (
    <div className="client-page">
      <div className="client-header">
        <h1>{company.name} Message Portal</h1>
        <p>Review missed-call text conversations in one place.</p>
      </div>

      <div className="client-header">
        <div className="client-header-top">
          <Link to="/" className="back-button">
            ← Back to Main Page
          </Link>
        </div>

        <h1>{company.name} Message Portal</h1>

        <p>
          Review missed-call text conversations in one place.
        </p>
      </div>

      <div className="client-layout">
        <aside className="conversation-list">
          {conversations.length === 0 && <p>No conversations yet.</p>}

          {conversations.map((convo) => (
            <button
              key={convo.id}
              className={
                selectedConversation?.id === convo.id
                  ? "conversation-card active"
                  : "conversation-card"
              }
              onClick={() => setSelectedConversation(convo)}
            >
              <strong>{convo.customer_phone}</strong>
              <small>
                {convo.created_at
                  ? new Date(convo.created_at).toLocaleString()
                  : "No date"}
              </small>
            </button>
          ))}
        </aside>

        <main className="message-thread">
          {selectedConversation ? (
            <>
              <h2>{selectedConversation.customer_phone}</h2>

              <div className="messages">
                {(selectedConversation.messages || [])
                  .sort(
                    (a, b) =>
                      new Date(a.created_at) - new Date(b.created_at)
                  )
                  .map((msg) => (
                    <div
                      key={msg.id}
                      className={
                        msg.direction === "inbound"
                          ? "message inbound"
                          : "message outbound"
                      }
                    >
                      <p>{msg.body}</p>
                      <small>
                        {msg.created_at
                          ? new Date(msg.created_at).toLocaleString()
                          : ""}
                      </small>
                    </div>
                  ))}
              </div>
            </>
          ) : (
            <p>Select a conversation.</p>
          )}
        </main>
      </div>
    </div>
  );
}

export default ClientMessages;